/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type GenericValidationError,
    GenericValidationErrorFromJSON,
    GenericValidationErrorToJSON,
} from '../models/GenericValidationError';
import {
    type RoleResponsePagedResult,
    RoleResponsePagedResultFromJSON,
    RoleResponsePagedResultToJSON,
} from '../models/RoleResponsePagedResult';
import {
    type RoleSearchOrderBy,
    RoleSearchOrderByFromJSON,
    RoleSearchOrderByToJSON,
} from '../models/RoleSearchOrderBy';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiRolesGetRequest {
    applicationId?: string;
    textFilter?: string;
    onlyEndUserAssignable?: boolean;
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: RoleSearchOrderBy;
}

/**
 * 
 */
export class RolesApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiRolesGet without sending the request
     */
    async apiRolesGetRequestOpts(requestParameters: ApiRolesGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['applicationId'] != null) {
            queryParameters['ApplicationId'] = requestParameters['applicationId'];
        }

        if (requestParameters['textFilter'] != null) {
            queryParameters['TextFilter'] = requestParameters['textFilter'];
        }

        if (requestParameters['onlyEndUserAssignable'] != null) {
            queryParameters['OnlyEndUserAssignable'] = requestParameters['onlyEndUserAssignable'];
        }

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/roles`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiRolesGetRaw(requestParameters: ApiRolesGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleResponsePagedResult>> {
        const requestOptions = await this.apiRolesGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiRolesGet(requestParameters: ApiRolesGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleResponsePagedResult> {
        const response = await this.apiRolesGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
